export default [
  {
    type: 'BOOLEAN',
    name: 'processed',
    defaultName: 'Processed',
  },
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'STRING',
    name: 'mediaType',
    defaultName: 'MediaType',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'profile',
    defaultName: 'Profile',
  },
  {
    type: 'STRING',
    name: 'mediaRel',
    defaultName: 'MediaRel',
  },
  {
    type: 'BOOLEAN',
    name: 'isPrivate',
    defaultName: 'Is Private',
  },
  {
    type: 'STRING',
    name: 'restrictions',
    defaultName: 'Restrictions',
  },
  {
    type: 'INT',
    name: 'likes',
    defaultName: 'Likes',
  },
  {
    type: 'STRING',
    name: 'mediaStatus',
    defaultName: 'Media Status',
  },
  {
    type: 'STRING',
    name: 'mediaInformation',
    defaultName: 'Media Information',
  },
  {
    type: 'STRING',
    name: 'mediaReactions',
    defaultName: 'Media Reactions',
  },
  {
    type: 'STRING',
    name: 'tag',
    defaultName: 'Tag',
  },
  {
    type: 'STRING',
    name: 'thumbnails',
    defaultName: 'Thumbnails',
  },
  {
    type: 'BOOLEAN',
    name: 'published',
    defaultName: 'Published',
  },
  {
    type: 'STRING',
    name: 'released',
    defaultName: 'Released',
  },
  {
    type: 'STRING',
    name: 'transparentTitleUrl',
    defaultName: 'Transparent Title Url',
  },
  {
    type: 'STRING',
    name: 'rating',
    defaultName: 'Rating',
  },
  {
    type: 'STRING',
    name: 'transparentTitleLocation',
    defaultName: 'Transparent Title Location',
  },
  {
    type: 'STRING',
    name: 'mediaRelLocation',
    defaultName: 'MediaRel Location',
  },
  {
    type: 'STRING',
    name: 'thumbnail',
    defaultName: 'Thumbnail',
  },
  {
    type: 'STRING',
    name: 'thumbnailLocation',
    defaultName: 'Thumbnail Location',
  },
  {
    type: 'STRING',
    name: 'mediaPreviewUrl',
    defaultName: 'Media Preview Url',
  },
  {
    type: 'STRING',
    name: 'mediaPreviewLocation',
    defaultName: 'Media Preview Location',
  },
  {
    type: 'DOUBLE',
    name: 'mediaPreviewDuration',
    defaultName: 'Media Preview Duration',
  },
  {
    type: 'STRING',
    name: 'mediaDuration',
    defaultName: 'Media Duration',
  },
  {
    type: 'BOOLEAN',
    name: 'hasProcessed',
    defaultName: 'Has Processed',
  },
  {
    type: 'DOUBLE',
    name: 'minimumAppropriateAge',
    defaultName: 'Minimum Appropriate Age',
  },
  {
    type: 'STRING',
    name: 'thumbnailDefaultUrl',
    defaultName: 'Thumbnail Default Url',
  },
]
